module.exports = __webpack_public_path__ + "static/media/submenu-pergunta.b2063aa1.svg";